<template>

    <div class="interface-mail-folder" @dragenter="onDragenter" @dragleave="onDragleave"  @dragover.prevent.stop="onDragOver($event)"
        v-on:drop.prevent.stop="onDrop($event)">

        <v-list-tile class="item" @click.native="$emit('select', folder.id)" :class="{'is-select': folder.id === selectId, onHover: onHover}">
            <v-list-tile-action class="interface-mail-folder__icon">
                <v-icon>{{ folderIcon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title>{{ folder.title }} ({{countMails}})</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action class="actions interface-mail-folder__dots" v-if="!folder.noedit">
                <FolderMenu @click.native.stop :folder-id="folder.id" :model="{folder, parentFolder}"/>
            </v-list-tile-action>
        </v-list-tile>

        <v-list v-if="folders.length" class="interface-mail-folder__childs">
            <interface-mail-folder v-for="(folderChild, index) in folders" :key="index"
                                   @select="onSelect"
                                   :mails="mails"
                                   :folder="folderChild"
                                   :select-id="selectId"
                                   @move-mail="$emit('move-mail', $event)"
                                   :parent-folder="folder"
                                   >
            </interface-mail-folder>
        </v-list>

    </div>

</template>

<script>
    import FolderMenu from './folder-menu.vue'

    export default {
        name: 'interface-mail-folder',
        data() {
            return {
                onHover: false
            }
        },
        props: {
            selectId: [Number, String],
            folder: Object,
            mails: {
                type: Array,
                default: () => []
            },
            parentFolder: Object
        },
        components: {
            FolderMenu
        },
        methods: {
            onSelect (id) {
                this.$emit('select', id)
            },
            onDragenter () {
                if (this.folder.sorted) {
                    this.onHover = true
                }
            },
            onDragleave () {
                if (this.folder.sorted) {
                    this.onHover = false
                }
            },
            onDragOver() {
                if (this.folder.sorted) {
                    // let info = JSON.parse(data.dataTransfer.types[0]).mailid
                    this.onHover = true
                }
            },
            onDrop(data) {
                if (this.folder.sorted) {
                    try {
                        let info = JSON.parse(data.dataTransfer.types[0]).mailid
                        this.onHover = false
                        if (this.folder.id == 0) {
                            let res = confirm('Вы действительно хотите удалить письмо?')
                            res && this.$emit('move-mail', {dstFolder: this.folder.id, mailId: info})
                        } else {
                            this.$emit('move-mail', {dstFolder: this.folder.id, mailId: info})
                        }
                    } catch (e) {
                        // empty
                    }
                }
            }
        },
        computed: {
            folderIcon () {
                return this.folder.icon || 'folder'
            },
            folders () {
                return this.folder.folders || []
            },
            countMails () {
                return this.mails.filter(item => item.folder === this.folder.id).length
            }
        }
    }
</script>

<style scoped lang="stylus">
    .interface-mail-folder {
        font-size 1.2rem
        cursor pointer

        &__icon {
            min-width 32px
        }

        &__dots {
            min-width 20px
        }

        &__childs {
            padding-left 1rem
        }

        .is-select {
            background-color #efefef
        }
        .onHover {
            border-radius 3px
            box-shadow inset 0 0 3px 1px rgba(83,114,242,1)
        }
    }

    .actions {
        opacity 1
        transition 0.3s opacity
    }
    .item:hover .actions {
        opacity 1
    }
</style>
